import React from "react";
import { ExclamationTriangleFill, InfoCircleFill } from "react-bootstrap-icons";
import PopupWrapper from "../../components/PopupWrapper";
import { LoadingButton } from "../../Utils/CustomComponent";

export const SMS_TERMS_URL = "https://superiorloanservicing.com/terms-of-service/";
export const SMS_PRIVACY_URL = "https://superiorloanservicing.com/privacy-policy/";
// Bump whenever the consent wording changes; stored with every opt-in/out record
export const SMS_CONSENT_VERSION = "2026-10-06";
export const SMS_OPT_IN_TEXT = `Superior Loan Servicing: By selecting this check box and entering your phone number, you agree to receive an OTP with your LoanlinQ login session. You also agree to the terms of service (${SMS_TERMS_URL}) and privacy policy (${SMS_PRIVACY_URL}). This agreement isn’t a condition of any purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out; HELP for more information.`;
export const SMS_OPT_OUT_TEXT =
  "Attention, you are opting out of receiving OTP via SMS. However, you will still receive an email for OTP to complete the LoanlinQ login process.";

const ExternalLink = ({ href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-underline"
  >
    {href}
  </a>
);

/**
 * Confirmation popup for SMS OTP opt-in / opt-out.
 * @param {boolean|null} pendingOptIn - true = confirming opt-in, false = confirming opt-out, null = hidden
 */
const SmsOptInModal = ({ pendingOptIn, loading, onConfirm, onCancel }) => {
  const isOptIn = pendingOptIn === true;

  return (
    <PopupWrapper
      title={isOptIn ? "Opt in to SMS OTP" : "Opt out of SMS OTP"}
      toShow={pendingOptIn !== null}
      closeEventHandler={onCancel}
      closeButton={!loading}
      backdrop="static"
      centered
      Component={
        <div>
          <div
            className={`alert ${isOptIn ? "alert-info" : "alert-warning"} p-4 border d-flex gap-4`}
            role="alert"
          >
            <div>
              {isOptIn ? (
                <InfoCircleFill size={24} />
              ) : (
                <ExclamationTriangleFill size={24} />
              )}
            </div>
            {isOptIn ? (
              <div>
                <strong>Superior Loan Servicing:</strong> By selecting this
                check box and entering your phone number, you agree to receive
                an OTP with your LoanlinQ login session. You also agree to the
                terms of service (<ExternalLink href={SMS_TERMS_URL} />) and
                privacy policy (<ExternalLink href={SMS_PRIVACY_URL} />). This
                agreement isn’t a condition of any purchase. Message frequency
                varies. Message and data rates may apply. Reply STOP to opt out;
                HELP for more information.
              </div>
            ) : (
              <div>{SMS_OPT_OUT_TEXT}</div>
            )}
          </div>
          <div className="d-flex justify-content-end gap-3 mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <LoadingButton
              type="button"
              className="btn btn-primary text-white"
              onClick={onConfirm}
              title={isOptIn ? "I Agree" : "Confirm Opt-Out"}
              disabled={loading}
              loading={loading}
            />
          </div>
        </div>
      }
    />
  );
};

export default SmsOptInModal;
